import angular from 'angular';
import {
    BuildCreateFormCallback,
    CanEditPeriodoCallback,
    CanManageMovimentacoesCallback,
    CreatePeriodoCallback,
    GetPeriodoCallback,
    UpdatePeriodoCallback
} from './movimentacoes-periodos.modal.model';
import { IMovimentacaoPeriodo } from '../../../models/movimentacoes-periodos.service.model';

export class MovimentacoesPeriodosModalService {
    static $inject = ['$uibModal'];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {}

    public open(
        periodos: IMovimentacaoPeriodo[],
        createPeriodo: CreatePeriodoCallback,
        updatePeriodo: UpdatePeriodoCallback,
        buildCreateForm: BuildCreateFormCallback,
        getPeriodo: GetPeriodoCallback,
        canManageMovimentacoes: CanManageMovimentacoesCallback,
        canEditPeriodo: CanEditPeriodoCallback
    ): ng.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./movimentacoes-periodos.modal.html'),
            controller: 'MovimentacoesPeriodosModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            windowClass: 'nsj-modal-lg-no-height',
            resolve: {
                periodos: () => angular.copy(periodos),
                createPeriodo: () => createPeriodo,
                updatePeriodo: () => updatePeriodo,
                buildCreateForm: () => buildCreateForm,
                getPeriodo: () => getPeriodo,
                canManageMovimentacoes: () => canManageMovimentacoes(),
                canEditPeriodo: () => canEditPeriodo()
            }
        });
    }
}
